export const rupee = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const rate = (v, unit) => `₹${Number(v || 0).toLocaleString("en-IN")} / ${unit || "Box"}`;

export const SIZES = ["600x1200mm", "800x1600mm", "600x600mm", "300x600mm", "400x400mm"];
export const SURFACES = ["Glossy", "Matt", "Vitrified", "High Gloss", "Carving", "Rustic"];
export const RATE_UNITS = ["Box", "Sq.ft", "Piece"];
export const TILE_TYPES = ["Wall", "Floor"];
export const CATEGORIES = [
  { value: "tiles", label: "Tiles" },
  { value: "sanitarywares", label: "Sanitarywares" },
  { value: "sinks", label: "Sinks" },
];
export const PIECE_BUILTINS = ["sanitarywares", "sinks"];
export const categoryLabel = (c) => (CATEGORIES.find((x) => x.value === c) || CATEGORIES[0]).label;
export const isTile = (p) => ((p?.category || "tiles") === "tiles");
export const isPieceBuiltin = (p) => PIECE_BUILTINS.includes(p?.category);
export const isGenericCat = (p) => !isTile(p) && !isPieceBuiltin(p);
export const stockUnit = (p) => (isTile(p) ? "Boxes" : "Pieces");
export const saleRate = (p) => {
  if (isTile(p)) return { value: p?.box_price ?? p?.rate_value ?? 0, unit: "Box" };
  if (isPieceBuiltin(p)) return { value: p?.pc_price ?? p?.rate_value ?? 0, unit: "Piece" };
  return { value: p?.rate_value ?? 0, unit: p?.rate_unit || "Piece" };
};

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
export const priceMain = (p) => {
  if (isTile(p)) {
    const sqft = p.clearance_price != null ? p.clearance_price : p.rate_value;
    if (sqft == null) return rate(p.rate_value, p.rate_unit);
    return `${inr(sqft)} / sq.ft`;
  }
  if (isPieceBuiltin(p)) {
    const pc = p.pc_price != null ? p.pc_price : p.rate_value;
    return `${inr(pc)} / piece`;
  }
  return `${inr(p.rate_value)} / ${(p.rate_unit || "piece").toLowerCase()}`;
};
export const priceBox = (p) => (isTile(p) && p.box_price != null ? `${inr(p.box_price)} / box` : null);
const baseRate = (p) => {
  if (isTile(p)) return p.clearance_price != null ? p.clearance_price : p.rate_value;
  if (isPieceBuiltin(p)) return p.pc_price != null ? p.pc_price : p.rate_value;
  return p.rate_value;
};
const rateUnitLabel = (p) => {
  if (isTile(p)) return "sq.ft";
  if (isPieceBuiltin(p)) return "piece";
  return (p.rate_unit || "piece").toLowerCase();
};
export const priceActual = (p) => {
  const base = baseRate(p);
  return p.actual_price != null && p.actual_price > (base ?? 0) ? `${inr(p.actual_price)} / ${rateUnitLabel(p)}` : null;
};
export const discountPct = (p) => {
  const base = baseRate(p);
  if (p.actual_price == null || base == null || p.actual_price <= base) return null;
  return Math.round(((p.actual_price - base) / p.actual_price) * 100);
};

export const TIERS = [
  { id: "p2999", price: 2999, products: 5 },
  { id: "p3999", price: 3999, products: 7 },
  { id: "p4999", price: 4999, products: 10 },
  { id: "p5999", price: 5999, products: 13 },
  { id: "p8999", price: 8999, products: 20 },
];
export const SLOT_PRICE_YEAR = 600;
export const packageLabel = (id) => {
  const t = TIERS.find((x) => x.id === id);
  return t ? `${t.products} Products` : "—";
};

export const STATUS_LABELS = {
  active: "Active",
  inactive: "Inactive",
  pending_approval: "Pending Approval",
  rejected: "Rejected",
  sold: "Sold / Cleared",
  expired: "Expired",
};

export const statusColor = (s) => ({
  active: "bg-emerald-100 text-emerald-800 border-emerald-300",
  inactive: "bg-slate-100 text-slate-700 border-slate-300",
  pending_approval: "bg-amber-100 text-amber-800 border-amber-300",
  rejected: "bg-rose-100 text-rose-800 border-rose-300",
  sold: "bg-blue-100 text-blue-800 border-blue-300",
  expired: "bg-slate-200 text-slate-600 border-slate-400",
  expiring: "bg-amber-100 text-amber-800 border-amber-300",
  no_subscription: "bg-slate-100 text-slate-600 border-slate-300",
  screenshot_uploaded: "bg-amber-100 text-amber-800 border-amber-300",
  approved: "bg-emerald-100 text-emerald-800 border-emerald-300",
  pending: "bg-slate-100 text-slate-700 border-slate-300",
}[s] || "bg-slate-100 text-slate-700 border-slate-300");

export function daysLabel(d) {
  if (d === null || d === undefined) return "—";
  if (d < 0) return "Expired";
  if (d === 0) return "Expires today";
  return `${d} day${d === 1 ? "" : "s"} left`;
}
